'use strict'

/**
 * Swatch Color class
 *
 * Color from project stored in database or in a file are converted
 * in SwatchColor object
 *
 * @class SwatchColor
 */
class SwatchColor {
    constructor(_obj) {
        this.id
        this.name
        this.name2
        this.position
        this.color_filename
        this.reflectance

        this.labl
        this.laba
        this.labb

        this.sr
        this.sg
        this.sb

        this.cmykc
        this.cmykm
        this.cmyky
        this.cmykk

        // Other properties
        this.type = 0

        if ('swatch_color' in _obj) {
            // Changer le nom de la méthode setColorFromColor
            this.setSwatchColor(_obj.swatch_color)
        } else {
            this.setSwatchColor(_obj)
        }
    }

    /**
     * Import swatchColor values
     * @param {*} data
     */
    setSwatchColor(data) {
        this.id = data.id

        this.name = data.name
        this.name2 = data.name2
        this.position = data.position
        this.color_filename = data.color_filename

        this.reflectance = data.reflectance

        this.labl = data.labl
        this.laba = data.laba
        this.labb = data.labb

        this.sr = data.sr
        this.sg = data.sg
        this.sb = data.sb

        this.cmykc = data.cmykc
        this.cmykm = data.cmykm
        this.cmyky = data.cmyky
        this.cmykk = data.cmykk

        // swatchColorCode/Name/Infos are derived on demand in Color.ensureExportSwatchData()
    }
}

export default SwatchColor
